import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Portfolio from './components/Portfolio';
import Projects from './components/Projects';
import Contact from './components/Contact'; // Import the Contact component
import About from './components/About'; // Import the About component
import TabBar from './components/TabBar';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} /> {/* Add the Contact route */}
          <Route path="/about" element={<About />} /> {/* Add the About route */}
        </Routes>
      </header>
      <div className="tab-bar-container">
        <TabBar />
      </div>
    </div>
  );
}

export default App;
